import type { FreeQuestionnaireBody, FreeQuestionnaireParams } from '@/models/interface/aiChat';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

const baseUrl: string = import.meta.env.VITE_FUNDAY_API_URL;

export class AiChatQuestionnaireService extends ApiFactory {
  constructor() {
    super(`${baseUrl}`);
  }

  /**
   * 建立 免費諮詢問卷(寄送 Email)
   * @params
   */
  createQuestionnaireV(
    body: FreeQuestionnaireBody[],
    params?: FreeQuestionnaireParams
  ): Promise<ApiDataResponse<string | null>> {
    return super.post(`v2/Questionnaire/Answer/free_consult`, body, {
      headers: {
        'Content-Type': 'application/json'
      },
      params: { ...params }
    });
  }
}
